import { useSetRecoilState } from "recoil";
import { conceptsAtom } from "../atoms/concepts.atom";
import ConceptsAPI from "../api/concepts";

const useConceptsAction = () => {
  const setConcepts = useSetRecoilState(conceptsAtom);

  const listConcepts = async(data, cb) => {
    setConcepts((prevValues) => ({ ...prevValues, loading: true }));
    try {
      const response = await ConceptsAPI.listConcepts(data);
      if (cb) {
        cb(response.data);
      }
      setConcepts((prevValues) => ({
        payload: response.data,
        loading: false,
        total: response.data.length,
        status: response.status,
      }));
    } catch (error) {
      setConcepts((prevValues) => ({
        ...prevValues,
        loading: false,
        message: "Error al listar conceptos",
        status: 500,
        error: JSON.stringify(error),
      }));
    }
  };

  const getConceptsExcel = async(cb) => {
    setConcepts((prevValues) => ({ ...prevValues, loading: true }));
    try {
      const response = await ConceptsAPI.getConceptsExcel();
      if (cb) {
        cb(response.data);
      }
    } catch (error) {
      setConcepts((prevValues) => ({
        ...prevValues,
        loading: false,
        message: "Error al obtener el excel de conceptos",
        status: 500,
        error: JSON.stringify(error),
      }));
    }
  };

  const resetConcepts = async() => {
    setConcepts((prevValues) => ({
      ...prevValues,
      payload: [],
      loading: false,
      total: 0
    }));
  }

  return { listConcepts, getConceptsExcel, resetConcepts };
};

export {useConceptsAction}
